import { StoreApi, UseBoundStore, useStore } from "zustand";
import { WecomChatStoreType, wecomChatStore } from "./wecom-chat-store";
import {
  wecomChatPersistentStore,
  WecomChatPersistentStoreType,
} from "./wecom-chat-persistent-store";

export const useWecomChatStore = useStore.bind(
  null,
  wecomChatStore.getStore()
) as UseBoundStore<StoreApi<WecomChatStoreType>>;

export const useWecomChatPersistentStore = useStore.bind(
  null,
  wecomChatPersistentStore.getStore()
) as UseBoundStore<StoreApi<WecomChatPersistentStoreType>>;
